export default function AdTypeController(
  CreativeService,
  PartnerService,
  ExamplesService
) {
  const vm = this;

  function initialize() {
    ExamplesService.getExamples().then(() => {
      CreativeService.setCreative(ExamplesService.examples[0].creative);
    });

    return PartnerService.get().then(partner => {
      vm.partner = partner;
    });
  }

  initialize();

  return vm;
}

AdTypeController.$inject = [
  'CreativeService',
  'PartnerService',
  'ExamplesService'
];
